import './App.css';
import './fonts/WinterKei.css';
import './fonts/Rubik.css';
import './fonts/Montserrat.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Display from './Pages/Display';
import Display2v2 from './Pages/Display2v2';
import Dashboard from './Pages/Dashboard';
import LiveGame from './Pages/LiveGame';
import LiveGameOverlay from './Pages/LiveGameOverlay';
import LiveGameDashboard from './Pages/Dashboard/LiveGameDashboard';
import PostGameDashboard from './Pages/Dashboard/PostGameDashboard';
import DraftDashboard from './Pages/Dashboard/DraftDashboard';
import SettingsDashboard from './Pages/Dashboard/Settings';
import DraftDisplay from './Pages/DraftDisplay';

import { QueryClient, QueryClientProvider, useQuery } from 'react-query'

const queryClient = new QueryClient()


function App() {
  return (
    <div>
      <QueryClientProvider client={queryClient}>

        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Display />} />
            <Route path="/2v2" element={<Display2v2 />} />
            <Route path="/LiveGame" element={<LiveGame />} />
            <Route path="/LiveGameOverlay" element={<LiveGameOverlay />} />
            <Route path="/DraftDisplay" element={<DraftDisplay />} />

            <Route path="/Dashboard" element={<Dashboard />}>
              {window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_LIVEGAME == "true" ?
                <Route path="LiveGame" element={<LiveGameDashboard />} />
                : <></>}
              {window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_POSTGAME == "true" ?
                <Route path="PostGame" element={<PostGameDashboard />} />
                : <></>}
              {window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_DRAFT == "true" ?
                <Route path="Draft" element={<DraftDashboard />} />
                : <></>}
              <Route path="Settings" element={<SettingsDashboard />} />
            </Route>

          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </div>
  )
}

export default App;
